import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IoCloseSharp } from 'react-icons/io5';
import { User } from '../../../../../model/user/User';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { Fancybox } from '../../../../../shared/components/Fancybox';
import { UploadImage } from '../../../../../shared/components/UploadImage';
import { getCorrectImageThumbnail, isBetween } from '../../../../../shared/functions/Functions';
import AlertBox from '../../../../../shared/components/alert/AlertBox';

interface IProfileHighlightedProps {
    user: User;
    isEditable?: boolean;
    handleDeleteFile: (postId: number) => void;
    files: Blob[] | MediaSource[] | undefined;
    setFiles: React.Dispatch<React.SetStateAction<Blob[] | MediaSource[] | undefined>>;
}

const ProfileHighlighted = ({
    user,
    isEditable = false,
    handleDeleteFile,
    files,
    setFiles,
}: IProfileHighlightedProps) => {
    const { t } = useTranslation();
    return (
        <div className="mb-4">
            <h6>{t('influencer.profile.highlightedPosts')}</h6>
            <p className="text-muted mb-2">{t('influencer.profile.highlightedPosts_desc')}</p>
            <AlertBox
                title=""
                desc={t('influencer.profile.highlightedPostsInfo')}
                variant="danger"
                classCol="w-fit-content"
                image="/icons/img-warning-gray.svg"
            />
            <Row className="mt-2">
                {user?.feedItems?.map(feed => {
                    return (
                        <Col md={2} key={feed?.id} className="my-1">
                            <div className="position-relative h-100 ">
                                {isEditable && user?.feedItems?.length > 3 && feed.isHighlighted && (
                                    <div
                                        className="highlighted-post-cancel scale-size-hover"
                                        onClick={() => handleDeleteFile(feed?.id)}
                                    >
                                        <IoCloseSharp />
                                    </div>
                                )}
                                <Fancybox>
                                    <div
                                        data-fancybox="gallery-feedItems"
                                        className="cursor-pointer w-100"
                                        data-src={
                                            feed?.postImages?.[0]?.externalLink ??
                                            feed?.postImages?.[0]?.path ??
                                            '/icons/filePlaceholder.png'
                                        }
                                    >
                                        <CustomImageHandler
                                            classes="highlighted-post"
                                            thumbnailPath={feed?.postImages?.[0]?.thumbnail}
                                            placeholder={getCorrectImageThumbnail(
                                                !!feed?.postImages?.[0]?.externalLink,
                                                feed?.postImages?.[0]?.name ?? '',
                                                feed?.postImages?.[0]?.thumbPath ?? '',
                                                feed?.postImages?.[0]?.path
                                            )}
                                            photoPath={getCorrectImageThumbnail(
                                                !!feed?.postImages?.[0]?.externalLink,
                                                feed?.postImages?.[0]?.name ?? '',
                                                feed?.postImages?.[0]?.thumbPath ?? '',
                                                feed?.postImages?.[0]?.path
                                            )}
                                            altTag={feed?.platform}
                                        />
                                    </div>
                                </Fancybox>
                            </div>
                        </Col>
                    );
                })}
                {isEditable && (
                    <>
                        <Col xs={12} className="mt-3 mb-5">
                            <UploadImage
                                numberOfFiles={files?.length}
                                saveFile={setFiles}
                                isDeleteHidden={true}
                                classes="px-0"
                                isSmall
                                acceptedFormats="video/*, image/jpeg, image/png, image/jpg"
                                isMultiple
                                maxSize={20971520}
                            />
                            {isBetween(user?.feedItems?.length, 3, 5) && (
                                <p className="text-danger text-end">{t('influencer.profile.maxHighlightedPost')}</p>
                            )}
                        </Col>
                    </>
                )}
            </Row>
        </div>
    );
};

export default ProfileHighlighted;
